import angular from "angular";
import uiRouter from "angular-ui-router";
import privacyComponent from "./privacy.component";

let privacyModule = angular
  .module("privacy", [uiRouter])
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("privacy", {
      url: "/{path:privacy|policy}",
      component: "privacy",
      data: { pageTitle: "Privacy" },
    });
  })
  .component("privacy", privacyComponent).name;

export default privacyModule;



// WEBPACK FOOTER //
// ./client/app/components/privacy/privacy.js